import { getSession, switchAccount } from '../services/auth';
import trackedNavigate from '../services/trackedNavigate';
import URLUtil from './URLUtil';

export default class RoutingUtil {
  static switchToAccount = (accountId, onSwitchCallback) => {
    if (accountId) {
      switchAccount(accountId, onSwitchCallback); // Refreshes the session
      const newPath = this.outputPathWithAccount("/switch-account", accountId);
      trackedNavigate(newPath, false, { accountId });
    }
  }

  static switchToSite = (siteId, accountId) => {
    if (siteId) {
      const newPath = this.outputPathWithAccount(`/sites/${siteId}`, accountId)
      trackedNavigate(newPath, false, { siteId });
    }
  }

  static switchToGroup = (groupId, accountId) => {
    if (groupId) {
      const newPath = this.outputPathWithAccount(`/groups/${groupId}`, accountId)
      trackedNavigate(newPath, false, { groupId });
    }
  }

  static getPathFromSession = (path) => {
    if (!path) return "";

    // Handle integer paths such as -1 for popping the history stack
    if (Number.isInteger(path)) return path;

    let newPath = path;
    const session = getSession();

    if (session?.agencyId && newPath.startsWith('/agency')) {
      newPath = this.outputPathWithAgency(newPath, session?.agencyId);
    } else if (session?.accountId) {
      newPath = this.outputPathWithAccount(newPath, session?.accountId);
    }

    return newPath;
  }


  static outputPathWithAccount = (originalPath = '', accountId) => {
    if (!accountId || Number.isInteger(originalPath)) return originalPath;

    if (originalPath === '') return `/a/${accountId}`;

    const pathMappings = {
      '/switch-account': `/a/${accountId}`,
      '/account': `/a/${accountId}/settings`,
      '/settings': `/a/${accountId}/settings`,
      '/dashboards': `/a/${accountId}/dashboards`,
      '/uptime': `/a/${accountId}/uptime`,
      '/profile': `/a/${accountId}/profile`,
      '/groups': `/a/${accountId}/groups`,
      '/sites': `/a/${accountId}/sites`,
      '/tasks': `/a/${accountId}/tasks`
    };
    const oldPath = Object.keys(pathMappings).find((key) => originalPath.startsWith(key));
    return oldPath ? originalPath.replace(oldPath, pathMappings[oldPath]) : originalPath;
  }

  static outputFullUrlWithAccount = (originalPath = '', accountId) => {
    return this.prependWithAppUrl(this.outputPathWithAccount(originalPath, accountId));
  }

  static outputPathWithAgency = (originalPath = '', agencyId) => {
    if (!agencyId || Number.isInteger(originalPath)) return originalPath;

    if (originalPath === '/agency' || originalPath === '') return `/agency/${agencyId}`;

    const pathMappings = {
      '/agency/users': `/agency/${agencyId}/users`,
      '/agency/accounts': `/agency/${agencyId}/accounts`,
    };
    const oldPath = Object.keys(pathMappings).find((key) => originalPath.startsWith(key));
    return oldPath ? originalPath.replace(oldPath, pathMappings[oldPath]) : originalPath;
  }

  static outputFullUrlWithAgency = (originalPath = '', agencyId) => {
    return this.prependWithAppUrl(this.outputPathWithAgency(originalPath, agencyId));
  }

  static extractIdsFromPath = (pathname) => ({
    accountId: URLUtil.extractIdAfterSubdirectory("a", pathname),
    siteId: URLUtil.extractIdAfterSubdirectory("sites", pathname),
    groupId: URLUtil.extractIdAfterSubdirectory("groups", pathname)
  });

  static prependWithAppUrl = (path) => {
    const loc = document.location;
    const { protocol, host } = loc;
    const newPath = path.startsWith('/') ? path : `/${path}`;
    return `${protocol}//${host}${newPath}`;
  };
};